export const NEWSLETTER_DISPLAYED_POPUP_LOCAL_STORAGE_KEY = 'newsletter-popup-displayed';
